export default class QueueResponse {
  constructor({
    total_tasks = 0,
    per_deadline_summary = [],
    tasks = [],
  }) {
    this.total_tasks = total_tasks;
    this.per_deadline_summary = per_deadline_summary;
    this.tasks = tasks;
  }

  // Enum for queue type
  static queueTypes = {
    PRE_CHECK: 'pre_check',
    DATASET: 'generate_dataset',
    EVALUATION: 'evaluation'
  }

  // Format date to DD.MM.YYYY HH:MM
  static formatDate(datetime) {
    const date = new Date(datetime);
    return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
  }

  static formatDateTime(datetime) {
      const date = new Date(datetime); // Automatically converts UTC to local timezone
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      return `${day}.${month}.${year} ${hours}:${minutes}`;
  }

  static getQueueTypeLabel(type) {
    switch (type) {
      case QueueResponse.queueTypes.PRE_CHECK:
        return 'Sanity Check';
      case QueueResponse.queueTypes.DATASET:
        return 'Generate Dataset';
      case QueueResponse.queueTypes.EVALUATION:
        return 'Evaluation';
      default:
        return type;
    }
  }
}

export class WorkerResponse {
  constructor({
    max_workers = 0,
    workers_summaries = []
  }) {
    this.max_workers = max_workers;
    this.workers_summaries = workers_summaries;
  }

  // Enum for worker type
  static workerTypes = {
    PRE_CHECK: 'pre_check',
    DATASET: 'generate_dataset',
    EVALUATION: 'evaluation'
  }

  // Format date to DD.MM.YYYY HH:MM
  static formatDate(date) {
    if (typeof date !== 'string') {
        if (date instanceof Date && !isNaN(date)) {
            date = date.toISOString();
        } else {
            try {
                date = new Date(date).toISOString();
            } catch (e) {
                console.error('Invalid date:', date);
                return '';
            }
        }
    }
    if (!date) return '';

    const [datePart, timePart] = date.split('T');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':').map(part => part.split('.')[0]);

    return `${day}.${month}.${year} ${hour}:${minute}`;
  }

  static getWorkerTypeLabel(type) {
    switch (type) {
      case WorkerResponse.workerTypes.PRE_CHECK:
        return 'Sanity Check';
      case WorkerResponse.workerTypes.DATASET:
        return 'Generate Dataset';
      case WorkerResponse.workerTypes.EVALUATION:
        return 'Evaluation';
      default:
        return type;
    }
  }
}
